export default "__VITE_ASSET__CBsGSfgO__"